import { render, staticRenderFns } from "./unitsList.vue?vue&type=template&id=54e09435"
import script from "./unitsList.vue?vue&type=script&lang=js"
export * from "./unitsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports